import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';

export const REGULATE_MIN = -100;
export const REGULATE_MAX = 100;
const REGULATE_OPTIONS = {
    suffix: '%',
    min: REGULATE_MIN,
    max: REGULATE_MAX,
};

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.PICTURE_FIX_RESET,
        content: '',
    },
    {
        type: FormItemType.SLIDER,
        name: FormItemName.SHARPEN_SOFTEN,
        label: FormItemLabelName.SHARPEN_SOFTEN,
        options: REGULATE_OPTIONS,
        defaultValue: 0,
    },
    {
        type: FormItemType.SLIDER,
        name: FormItemName.BRIGHTNESS,
        label: FormItemLabelName.BRIGHTNESS,
        options: REGULATE_OPTIONS,
        defaultValue: 0,
    },
    {
        type: FormItemType.SLIDER,
        name: FormItemName.CONSTRAST,
        label: FormItemLabelName.CONSTRAST,
        options: REGULATE_OPTIONS,
        defaultValue: 0,
    },
];
